
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Smartphone, Code, Search } from 'lucide-react';

const MobileAppsCallToAction = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-100">
      <div className="container">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            <span className="text-blue-600">Kostenloser</span> App-Konzept Workshop
          </h2>
          <p className="text-xl text-gray-700 mb-12">
            Lassen Sie uns gemeinsam Ihre App-Idee konkretisieren und das Potenzial für Ihr Unternehmen aufzeigen.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Search className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">App-Idee analysieren</h3>
                <p className="text-gray-600">
                  Wir besprechen Ihre App-Idee, identifizieren Zielgruppen und definieren klare Ziele und Erfolgskriterien.
                </p>
              </CardContent>
            </Card>
            
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Code className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">Technische Machbarkeit</h3>
                <p className="text-gray-600">
                  Wir prüfen die technische Umsetzbarkeit und empfehlen die optimale Entwicklungsstrategie für Ihre Anforderungen.
                </p>
              </CardContent>
            </Card>
            
            <Card className="h-full">
              <CardContent className="p-6 flex flex-col h-full items-center text-center">
                <div className="rounded-full bg-blue-100 p-4 mb-4">
                  <Smartphone className="h-8 w-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold mb-3">Klares Konzept</h3>
                <p className="text-gray-600">
                  Nach dem Workshop erhalten Sie ein erstes Konzept mit Funktionsumfang, Zeitplan und einer realistischen Kostenschätzung.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <Button asChild size="lg" className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-6 text-lg">
            <a href="#contact">Jetzt kostenlosen App-Workshop vereinbaren</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MobileAppsCallToAction;
